import React from "react"
import PropTypes from "prop-types"

const Youtube = ({ fillColor }) => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 18 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M16.9844 1.78405L17.0052 1.9155C16.8039 1.2254 16.2602 0.6929 15.5694 0.499082L15.5548 0.495729C14.2558 0.155038 9.02854 0.155039 9.02854 0.155039C9.02854 0.155039 3.81444 0.148332 2.50224 0.495729C1.79823 0.6929 1.25391 1.2254 1.05604 1.90141L1.05256 1.9155C0.567257 4.36404 0.563785 7.30619 1.07409 9.92776L1.05256 9.79497C1.25391 10.4851 1.79753 11.0176 2.48835 11.2114L2.50293 11.2147C3.80055 11.5561 9.02923 11.5561 9.02923 11.5561C9.02923 11.5561 14.2426 11.5561 15.5555 11.2147C16.2602 11.0176 16.8046 10.4851 17.0024 9.80905L17.0059 9.79497C17.2267 8.65621 17.353 7.34575 17.353 6.00714C17.353 5.95818 17.353 5.90855 17.3523 5.85892C17.353 5.81332 17.353 5.75899 17.353 5.70467C17.353 4.36538 17.2267 3.05493 16.9844 1.78405ZM7.36086 8.30411V3.41306L11.7113 5.86228L7.36086 8.30411Z"
      fill={fillColor}
    />
  </svg>
)

Youtube.propsTypes = {
  fillColor: PropTypes.string,
}

Youtube.defaultProps = {
  fillColor: "#E9E9E9",
}

export { Youtube }
